import { render, staticRenderFns } from "./ComparisonChart.vue?vue&type=template&id=61af1d96&scoped=true&"
import script from "./ComparisonChart.vue?vue&type=script&lang=js&"
export * from "./ComparisonChart.vue?vue&type=script&lang=js&"
import style0 from "./ComparisonChart.vue?vue&type=style&index=0&id=61af1d96&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61af1d96",
  null
  
)

export default component.exports